import { render, staticRenderFns } from "./paymentResult.vue?vue&type=template&id=d4b66a8e&scoped=true&"
import script from "./paymentResult.vue?vue&type=script&lang=ts&"
export * from "./paymentResult.vue?vue&type=script&lang=ts&"
import style0 from "./paymentResult.vue?vue&type=style&index=0&id=d4b66a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b66a8e",
  null
  
)

export default component.exports